module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<label class="warranted-checkbox checkbox">\n    <div class="warranted-checkbox__wrapper">\n        <input type="checkbox" data-layer-name="Высокая вероятность подтверждения">\n        <div class="checkboxStyle"><span class="icon icon-i16_check_thin"></span></div>\n        <span class="js-warranted-confirmation-icon"></span>\n        <span class="warranted-checkbox__name">\n            '+
((__t=(name))==null?'':__t)+
'\n        </span>\n    </div>\n    <ul class="warranted-checkbox__list">\n        ';
 _.each(additionals, function(item, key, list){ 
__p+='\n            <li class="warranted-checkbox__item">'+
((__t=( item.text ))==null?'':__t)+
'</li>\n        ';
 }) 
__p+='\n    </ul>\n</label>\n';
}
return __p;
};
